const animationJSON = {
  AOM39101: [
    {
      h_res: 256,
      v_res: 512,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 17,
          ko: 17,
          ja: 17,
        },
        midium: {
          en: 23,
          ko: 25,
          ja: 23,
        },
        large: {
          en: 30,
          ko: 75,
          ja: 30,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 64,
              left: 128,
            },
            center: {
              top: 128,
              left: 128,
            },
            bottom: {
              top: 191,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 67,
              left: 128,
            },
            center: {
              top: 128,
              left: 128,
            },
            bottom: {
              top: 198,
              left: 128,
            },
          },
          large: {
            top: {
              top: 67,
              left: 128,
            },
            center: {
              top: 128,
              left: 128,
            },
            bottom: {
              top: 198,
              left: 128,
            },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 512,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 17,
          ko: 17,
          ja: 17,
        },
        midium: {
          en: 23,
          ko: 25,
          ja: 23,
        },
        large: {
          en: 30,
          ko: 75,
          ja: 30,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 49,
              left: 128,
            },
            center: {
              top: 115,
              left: 128,
            },
            bottom: {
              top: 177,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 42,
              left: 128,
            },
            center: {
              top: 115,
              left: 128,
            },
            bottom: {
              top: 170,
              left: 128,
            },
          },
          large: {
            top: {
              top: 42,
              left: 128,
            },
            center: {
              top: 95,
              left: 128,
            },
            bottom: {
              top: 170,
              left: 128,
            },
          },
        },
        second_line: {
          small: {
            top: {
              top: 78,
              left: 128,
            },
            center: {
              top: 155,
              left: 128,
            },
            bottom: {
              top: 206,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 86,
              left: 128,
            },
            center: {
              top: 155,
              left: 128,
            },
            bottom: {
              top: 214,
              left: 128,
            },
          },
          large: {
            top: {
              top: 86,
              left: 128,
            },
            center: {
              top: 175,
              left: 128,
            },
            bottom: {
              top: 214,
              left: 128,
            },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 320,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 33,
          ko: 33,
          ja: 33,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 80, left: 128 },
            center: { top: 160, left: 128 },
            bottom: { top: 240, left: 128 },
          },
          midium: {
            top: { top: 80, left: 128 },
            center: { top: 160, left: 128 },
            bottom: { top: 240, left: 128 },
          },
          large: {
            top: { top: 80, left: 128 },
            center: { top: 160, left: 128 },
            bottom: { top: 240, left: 128 },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 320,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 33,
          ko: 33,
          ja: 33,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 69, left: 128 },
            center: { top: 149, left: 128 },
            bottom: { top: 229, left: 128 },
          },
          midium: {
            top: { top: 64, left: 128 },
            center: { top: 144, left: 128 },
            bottom: { top: 224, left: 128 },
          },
          large: {
            top: { top: 60, left: 128 },
            center: { top: 140, left: 128 },
            bottom: { top: 220, left: 128 },
          },
        },
        second_line: {
          small: {
            top: { top: 94, left: 128 },
            center: { top: 174, left: 128 },
            bottom: { top: 254, left: 128 },
          },
          midium: {
            top: { top: 98, left: 128 },
            center: { top: 178, left: 128 },
            bottom: { top: 258, left: 128 },
          },
          large: {
            top: { top: 102, left: 128 },
            center: { top: 182, left: 128 },
            bottom: { top: 262, left: 128 },
          },
        },
      },
    },
    {
      h_res: 128,
      v_res: 256,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 30,
          ko: 72,
          ja: 30,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 9, left: 33 },
            center: { top: 9, left: 64 },
            bottom: { top: 9, left: 95 },
          },
          midium: {
            top: { top: 9, left: 33 },
            center: { top: 9, left: 64 },
            bottom: { top: 9, left: 95 },
          },
          large: {
            top: { top: 9, left: 33 },
            center: { top: 9, left: 64 },
            bottom: { top: 9, left: 95 },
          },
        },
      },
    },
    {
      h_res: 128,
      v_res: 256,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 30,
          ko: 30,
          ja: 30,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 9, left: 42 },
            center: { top: 9, left: 42 },
            bottom: { top: 9, left: 42 },
          },
          midium: {
            top: { top: 9, left: 42 },
            center: { top: 9, left: 42 },
            bottom: { top: 9, left: 42 },
          },
          large: {
            top: { top: 9, left: 42 },
            center: { top: 9, left: 42 },
            bottom: { top: 9, left: 42 },
          },
        },
        second_line: {
          small: {
            top: { top: 9, left: 86 },
            center: { top: 9, left: 86 },
            bottom: { top: 9, left: 86 },
          },
          midium: {
            top: { top: 9, left: 86 },
            center: { top: 9, left: 86 },
            bottom: { top: 9, left: 86 },
          },
          large: {
            top: { top: 9, left: 86 },
            center: { top: 9, left: 86 },
            bottom: { top: 9, left: 86 },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 128,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 33,
          ko: 80,
          ja: 33,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 24,
              left: 128,
            },
            center: {
              top: 64,
              left: 128,
            },
            bottom: {
              top: 102,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 24,
              left: 128,
            },
            center: {
              top: 64,
              left: 128,
            },
            bottom: {
              top: 102,
              left: 128,
            },
          },
          large: {
            top: {
              top: 70,
              left: 128,
            },
            center: {
              top: 70,
              left: 128,
            },
            bottom: {
              top: 70,
              left: 128,
            },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 128,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 33,
          ko: 33,
          ja: 33,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 21, left: 128 },
            center: { top: 49, left: 128 },
            bottom: { top: 76, left: 128 },
          },
          midium: {
            top: { top: 19, left: 128 },
            center: { top: 42, left: 128 },
            bottom: { top: 74, left: 128 },
          },
          large: {
            top: { top: 41, left: 128 },
            center: { top: 41, left: 128 },
            bottom: { top: 41, left: 128 },
          },
        },
        second_line: {
          small: {
            top: { top: 51, left: 128 },
            center: { top: 82, left: 128 },
            bottom: { top: 108, left: 128 },
          },
          midium: {
            top: { top: 54, left: 128 },
            center: { top: 86, left: 128 },
            bottom: { top: 108, left: 128 },
          },
          large: {
            top: { top: 93, left: 128 },
            center: { top: 93, left: 128 },
            bottom: { top: 93, left: 128 },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 128,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 33,
          ko: 80,
          ja: 33,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 24,
              left: 128,
            },
            center: {
              top: 64,
              left: 128,
            },
            bottom: {
              top: 102,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 24,
              left: 128,
            },
            center: {
              top: 64,
              left: 128,
            },
            bottom: {
              top: 102,
              left: 128,
            },
          },
          large: {
            top: {
              top: 70,
              left: 128,
            },
            center: {
              top: 70,
              left: 128,
            },
            bottom: {
              top: 70,
              left: 128,
            },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 128,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 23,
          ko: 23,
          ja: 23,
        },
        large: {
          en: 33,
          ko: 33,
          ja: 33,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 21, left: 128 },
            center: { top: 49, left: 128 },
            bottom: { top: 76, left: 128 },
          },
          midium: {
            top: { top: 19, left: 128 },
            center: { top: 42, left: 128 },
            bottom: { top: 74, left: 128 },
          },
          large: {
            top: { top: 41, left: 128 },
            center: { top: 41, left: 128 },
            bottom: { top: 41, left: 128 },
          },
        },
        second_line: {
          small: {
            top: { top: 51, left: 128 },
            center: { top: 82, left: 128 },
            bottom: { top: 108, left: 128 },
          },
          midium: {
            top: { top: 54, left: 128 },
            center: { top: 86, left: 128 },
            bottom: { top: 108, left: 128 },
          },
          large: {
            top: { top: 93, left: 128 },
            center: { top: 93, left: 128 },
            bottom: { top: 93, left: 128 },
          },
        },
      },
    },
    {
      h_res: 512,
      v_res: 128,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 44,
          ko: 44,
          ja: 44,
        },
        large: {
          en: 60,
          ko: 80,
          ja: 60,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        large: {
          en: 8,
          ko: 6,
          ja: 8,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 26,
              left: 256,
            },
            center: {
              top: 64,
              left: 256,
            },
            bottom: {
              top: 102,
              left: 256,
            },
          },
          midium: {
            top: {
              top: 33,
              left: 256,
            },
            center: {
              top: 64,
              left: 256,
            },
            bottom: {
              top: 94,
              left: 256,
            },
          },
          large: {
            top: {
              top: 70,
              left: 256,
            },
            center: {
              top: 70,
              left: 256,
            },
            bottom: {
              top: 70,
              left: 256,
            },
          },
        },
      },
    },
    {
      h_res: 512,
      v_res: 128,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 44,
          ko: 44,
          ja: 44,
        },
        large: {
          en: 60,
          ko: 60,
          ja: 60,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        large: {
          en: 8,
          ko: 8,
          ja: 8,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 33, left: 256 },
            center: { top: 33, left: 256 },
            bottom: { top: 33, left: 256 },
          },
          midium: {
            top: { top: 33, left: 256 },
            center: { top: 33, left: 256 },
            bottom: { top: 33, left: 256 },
          },
          large: {
            top: { top: 38, left: 256 },
            center: { top: 38, left: 256 },
            bottom: { top: 38, left: 256 },
          },
        },
        second_line: {
          small: {
            top: { top: 95, left: 256 },
            center: { top: 95, left: 256 },
            bottom: { top: 95, left: 256 },
          },
          midium: {
            top: { top: 95, left: 256 },
            center: { top: 95, left: 256 },
            bottom: { top: 95, left: 256 },
          },
          large: {
            top: { top: 95, left: 256 },
            center: { top: 95, left: 256 },
            bottom: { top: 95, left: 256 },
          },
        },
      },
    },
    {
      h_res: 768,
      v_res: 128,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 30,
          ko: 30,
          ja: 30,
        },
        midium: {
          en: 44,
          ko: 44,
          ja: 44,
        },
        large: {
          en: 55,
          ko: 80,
          ja: 55,
        },
      },
      text_limit: {
        small: {
          en: 19,
          ko: 19,
          ja: 19,
        },
        midium: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        large: {
          en: 13,
          ko: 9,
          ja: 13,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 26, left: 384 },
            center: { top: 64, left: 384 },
            bottom: { top: 102, left: 384 },
          },
          midium: {
            top: { top: 33, left: 384 },
            center: { top: 64, left: 384 },
            bottom: { top: 94, left: 384 },
          },
          large: {
            top: { top: 68, left: 384 },
            center: { top: 68, left: 384 },
            bottom: { top: 68, left: 384 },
          },
        },
      },
    },
    {
      h_res: 768,
      v_res: 128,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 44,
          ko: 44,
          ja: 44,
        },
        large: {
          en: 55,
          ko: 55,
          ja: 55,
        },
      },
      text_limit: {
        small: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        midium: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        large: {
          en: 13,
          ko: 13,
          ja: 13,
        },
      },
      text_position: {
        first_line: {
          small: {
            center: {
              top: 38,
              left: 384,
            },
          },
          midium: {
            center: {
              top: 38,
              left: 384,
            },
          },
          large: {
            center: {
              top: 38,
              left: 384,
            },
          },
        },
        second_line: {
          small: {
            center: {
              top: 95,
              left: 384,
            },
          },
          midium: {
            center: {
              top: 95,
              left: 384,
            },
          },
          large: {
            center: {
              top: 95,
              left: 384,
            },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 256,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 17,
          ko: 17,
          ja: 17,
        },
        midium: {
          en: 23,
          ko: 25,
          ja: 23,
        },
        large: {
          en: 30,
          ko: 75,
          ja: 30,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 64,
              left: 128,
            },
            center: {
              top: 128,
              left: 128,
            },
            bottom: {
              top: 191,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 67,
              left: 128,
            },
            center: {
              top: 128,
              left: 128,
            },
            bottom: {
              top: 198,
              left: 128,
            },
          },
          large: {
            top: {
              top: 67,
              left: 128,
            },
            center: {
              top: 128,
              left: 128,
            },
            bottom: {
              top: 198,
              left: 128,
            },
          },
        },
      },
    },
    {
      h_res: 256,
      v_res: 256,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 17,
          ko: 17,
          ja: 17,
        },
        midium: {
          en: 23,
          ko: 25,
          ja: 23,
        },
        large: {
          en: 30,
          ko: 75,
          ja: 30,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 9,
          ko: 9,
          ja: 9,
        },
        large: {
          en: 7,
          ko: 3,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 49,
              left: 128,
            },
            center: {
              top: 115,
              left: 128,
            },
            bottom: {
              top: 177,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 42,
              left: 128,
            },
            center: {
              top: 115,
              left: 128,
            },
            bottom: {
              top: 170,
              left: 128,
            },
          },
          large: {
            top: {
              top: 42,
              left: 128,
            },
            center: {
              top: 95,
              left: 128,
            },
            bottom: {
              top: 170,
              left: 128,
            },
          },
        },
        second_line: {
          small: {
            top: {
              top: 78,
              left: 128,
            },
            center: {
              top: 155,
              left: 128,
            },
            bottom: {
              top: 206,
              left: 128,
            },
          },
          midium: {
            top: {
              top: 86,
              left: 128,
            },
            center: {
              top: 155,
              left: 128,
            },
            bottom: {
              top: 214,
              left: 128,
            },
          },
          large: {
            top: {
              top: 86,
              left: 128,
            },
            center: {
              top: 175,
              left: 128,
            },
            bottom: {
              top: 214,
              left: 128,
            },
          },
        },
      },
    },
    {
      h_res: 512,
      v_res: 256,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 45,
          ko: 45,
          ja: 45,
        },
        large: {
          en: 58,
          ko: 58,
          ja: 58,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        large: {
          en: 8,
          ko: 8,
          ja: 8,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 52,
              left: 256,
            },
            center: {
              top: 128,
              left: 256,
            },
            bottom: {
              top: 204,
              left: 256,
            },
          },
          midium: {
            top: {
              top: 52,
              left: 256,
            },
            center: {
              top: 128,
              left: 256,
            },
            bottom: {
              top: 204,
              left: 256,
            },
          },
          large: {
            top: {
              top: 52,
              left: 256,
            },
            center: {
              top: 128,
              left: 256,
            },
            bottom: {
              top: 204,
              left: 256,
            },
          },
        },
      },
    },
    {
      h_res: 512,
      v_res: 256,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 45,
          ko: 45,
          ja: 45,
        },
        large: {
          en: 58,
          ko: 80,
          ja: 58,
        },
      },
      text_limit: {
        small: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        midium: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        large: {
          en: 8,
          ko: 6,
          ja: 8,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 34,
              left: 256,
            },
            center: {
              top: 98,
              left: 256,
            },
            bottom: {
              top: 162,
              left: 256,
            },
          },
          midium: {
            top: {
              top: 34,
              left: 256,
            },
            center: {
              top: 98,
              left: 256,
            },
            bottom: {
              top: 162,
              left: 256,
            },
          },
          large: {
            top: {
              top: 82,
              left: 256,
            },
            center: {
              top: 82,
              left: 256,
            },
            bottom: {
              top: 82,
              left: 256,
            },
          },
        },
        second_line: {
          small: {
            top: {
              top: 92,
              left: 256,
            },
            center: {
              top: 156,
              left: 256,
            },
            bottom: {
              top: 220,
              left: 256,
            },
          },
          midium: {
            top: {
              top: 92,
              left: 256,
            },
            center: {
              top: 156,
              left: 256,
            },
            bottom: {
              top: 220,
              left: 256,
            },
          },
          large: {
            top: {
              top: 174,
              left: 256,
            },
            center: {
              top: 174,
              left: 256,
            },
            bottom: {
              top: 174,
              left: 256,
            },
          },
        },
      },
    },
    {
      h_res: 768,
      v_res: 384,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 63,
          ko: 63,
          ja: 63,
        },
        large: {
          en: 84,
          ko: 84,
          ja: 84,
        },
      },
      text_limit: {
        small: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        midium: {
          en: 11,
          ko: 11,
          ja: 11,
        },
        large: {
          en: 8,
          ko: 8,
          ja: 8,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 78,
              left: 384,
            },
            center: {
              top: 192,
              left: 384,
            },
            bottom: {
              top: 306,
              left: 384,
            },
          },
          midium: {
            top: {
              top: 78,
              left: 384,
            },
            center: {
              top: 192,
              left: 384,
            },
            bottom: {
              top: 306,
              left: 384,
            },
          },
          large: {
            top: {
              top: 78,
              left: 384,
            },
            center: {
              top: 192,
              left: 384,
            },
            bottom: {
              top: 306,
              left: 384,
            },
          },
        },
      },
    },
    {
      h_res: 768,
      v_res: 384,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 32,
          ko: 32,
          ja: 32,
        },
        midium: {
          en: 63,
          ko: 63,
          ja: 63,
        },
        large: {
          en: 84,
          ko: 80,
          ja: 84,
        },
      },
      text_limit: {
        small: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        midium: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        large: {
          en: 8,
          ko: 9,
          ja: 8,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 51,
              left: 384,
            },
            center: {
              top: 147,
              left: 384,
            },
            bottom: {
              top: 243,
              left: 384,
            },
          },
          midium: {
            top: {
              top: 51,
              left: 384,
            },
            center: {
              top: 147,
              left: 384,
            },
            bottom: {
              top: 243,
              left: 384,
            },
          },
          large: {
            top: {
              top: 126,
              left: 384,
            },
            center: {
              top: 126,
              left: 384,
            },
            bottom: {
              top: 126,
              left: 384,
            },
          },
        },
        second_line: {
          small: {
            top: {
              top: 138,
              left: 384,
            },
            center: {
              top: 234,
              left: 384,
            },
            bottom: {
              top: 330,
              left: 384,
            },
          },
          midium: {
            top: {
              top: 138,
              left: 384,
            },
            center: {
              top: 234,
              left: 384,
            },
            bottom: {
              top: 330,
              left: 384,
            },
          },
          large: {
            top: {
              top: 258,
              left: 384,
            },
            center: {
              top: 258,
              left: 384,
            },
            bottom: {
              top: 258,
              left: 384,
            },
          },
        },
      },
    },
  ],
  AOM62501: [
    {
      h_res: 80,
      v_res: 160,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 18,
          ko: 18,
          ja: 18,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 48,
          ko: 48,
          ja: 48,
        },
      },
      text_limit: {
        small: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        midium: {
          en: 4,
          ko: 4,
          ja: 4,
        },
        large: {
          en: 3,
          ko: 3,
          ja: 3,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 0, left: 20 },
            center: { top: 0, left: 40 },
            bottom: { top: 0, left: 60 },
          },
          midium: {
            top: { top: 0, left: 25 },
            center: { top: 0, left: 40 },
            bottom: { top: 0, left: 55 },
          },
          large: {
            top: { top: 0, left: 25 },
            center: { top: 0, left: 40 },
            bottom: { top: 0, left: 55 },
          },
        },
      },
    },
    {
      h_res: 80,
      v_res: 160,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 18,
          ko: 18,
          ja: 18,
        },
        midium: {
          en: 33,
          ko: 33,
          ja: 33,
        },
        large: {
          en: 48,
          ko: 48,
          ja: 48,
        },
      },
      text_limit: {
        small: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        midium: {
          en: 4,
          ko: 4,
          ja: 4,
        },
        large: {
          en: 3,
          ko: 3,
          ja: 3,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 0, left: 12 },
            center: { top: 0, left: 24 },
            bottom: { top: 0, left: 46 },
          },
          midium: {
            top: { top: 0, left: 22 },
            center: { top: 0, left: 22 },
            bottom: { top: 0, left: 22 },
          },
          large: {
            top: { top: 0, left: 12 },
            center: { top: 0, left: 29 },
            bottom: { top: 0, left: 46 },
          },
        },
        second_line: {
          small: {
            top: { top: 0, left: 34 },
            center: { top: 0, left: 56 },
            bottom: { top: 0, left: 68 },
          },
          midium: {
            top: { top: 0, left: 58 },
            center: { top: 0, left: 58 },
            bottom: { top: 0, left: 58 },
          },
          large: {
            top: { top: 0, left: 34 },
            center: { top: 0, left: 51 },
            bottom: { top: 0, left: 68 },
          },
        },
      },
    },
    {
      h_res: 160,
      v_res: 80,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 50,
          ko: 50,
          ja: 50,
        },
      },
      text_limit: {
        small: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        midium: {
          en: 4,
          ko: 4,
          ja: 4,
        },
        large: {
          en: 3,
          ko: 3,
          ja: 3,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 20, left: 80 },
            center: { top: 40, left: 80 },
            bottom: { top: 60, left: 80 },
          },
          midium: {
            top: { top: 35, left: 80 },
            center: { top: 43, left: 80 },
            bottom: { top: 50, left: 80 },
          },
          large: {
            top: { top: 35, left: 80 },
            center: { top: 45, left: 80 },
            bottom: { top: 50, left: 80 },
          },
        },
      },
    },
    {
      h_res: 160,
      v_res: 80,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 30,
          ko: 30,
          ja: 30,
        },
        large: {
          en: 40,
          ko: 40,
          ja: 40,
        },
      },
      text_limit: {
        small: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        midium: {
          en: 4,
          ko: 4,
          ja: 4,
        },
        large: {
          en: 3,
          ko: 3,
          ja: 3,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 20,
              left: 80,
            },
            center: {
              top: 30,
              left: 80,
            },
            bottom: {
              top: 40,
              left: 80,
            },
          },
          midium: {
            top: {
              top: 25,
              left: 80,
            },
            center: {
              top: 25,
              left: 80,
            },
            bottom: {
              top: 25,
              left: 80,
            },
          },
          large: {
            top: {
              top: 20,
              left: 80,
            },
            center: {
              top: 30,
              left: 80,
            },
            bottom: {
              top: 40,
              left: 80,
            },
          },
        },
        second_line: {
          small: {
            top: {
              top: 45,
              left: 80,
            },
            center: {
              top: 55,
              left: 80,
            },
            bottom: {
              top: 65,
              left: 80,
            },
          },
          midium: {
            top: {
              top: 59,
              left: 80,
            },
            center: {
              top: 59,
              left: 80,
            },
            bottom: {
              top: 59,
              left: 80,
            },
          },
          large: {
            top: {
              top: 45,
              left: 80,
            },
            center: {
              top: 55,
              left: 80,
            },
            bottom: {
              top: 65,
              left: 80,
            },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 80,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 24,
          ko: 24,
          ja: 24,
        },
        midium: {
          en: 38,
          ko: 38,
          ja: 38,
        },
        large: {
          en: 65,
          ko: 50,
          ja: 65,
        },
      },
      text_limit: {
        small: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        midium: {
          en: 6,
          ko: 8,
          ja: 6,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 24,
              left: 160,
            },
            center: {
              top: 40,
              left: 160,
            },
            bottom: {
              top: 57,
              left: 160,
            },
          },
          midium: {
            top: {
              top: 40,
              left: 160,
            },
            center: {
              top: 40,
              left: 160,
            },
            bottom: {
              top: 40,
              left: 160,
            },
          },
          large: {
            top: {
              top: 30,
              left: 160,
            },
            center: {
              top: 40,
              left: 160,
            },
            bottom: {
              top: 55,
              left: 160,
            },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 80,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 24,
          ko: 24,
          ja: 24,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 34,
          ko: 34,
          ja: 34,
        },
      },
      text_limit: {
        small: {
          en: 10,
          ko: 10,
          ja: 10,
        },
        midium: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 20, left: 160 },
            center: { top: 23, left: 160 },
            bottom: { top: 30, left: 160 },
          },
          midium: {
            top: { top: 21, left: 160 },
            center: { top: 21, left: 160 },
            bottom: { top: 21, left: 160 },
          },
          large: {
            top: { top: 18, left: 160 },
            center: { top: 23, left: 160 },
            bottom: { top: 28, left: 160 },
          },
        },
        second_line: {
          small: {
            top: { top: 54, left: 160 },
            center: { top: 57, left: 160 },
            bottom: { top: 64, left: 160 },
          },
          midium: {
            top: { top: 59, left: 160 },
            center: { top: 59, left: 160 },
            bottom: { top: 59, left: 160 },
          },
          large: {
            top: { top: 52, left: 160 },
            center: { top: 57, left: 160 },
            bottom: { top: 62, left: 160 },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 64,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        midium: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        large: {
          en: 59,
          ko: 59,
          ja: 59,
        },
      },
      text_limit: {
        small: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        midium: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        large: {
          en: 5,
          ko: 5,
          ja: 5,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 999,
              left: 999,
            },
            center: {
              top: 999,
              left: 999,
            },
            bottom: {
              top: 999,
              left: 999,
            },
          },
          midium: {
            top: {
              top: 999,
              left: 999,
            },
            center: {
              top: 999,
              left: 999,
            },
            bottom: {
              top: 999,
              left: 999,
            },
          },
          large: {
            top: {
              top: 999,
              left: 999,
            },
            center: {
              top: 34,
              left: 160,
            },
            bottom: {
              top: 999,
              left: 999,
            },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 64,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 30,
          ko: 30,
          ja: 30,
        },
        midium: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        large: {
          en: 0,
          ko: 0,
          ja: 0,
        },
      },
      text_limit: {
        small: {
          en: 11,
          ko: 11,
          ja: 11,
        },
        midium: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        large: {
          en: 0,
          ko: 0,
          ja: 0,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 999, left: 999 },
            center: { top: 17, left: 160 },
            bottom: { top: 999, left: 999 },
          },
          midium: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
          large: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
        },
        second_line: {
          small: {
            top: { top: 999, left: 999 },
            center: { top: 47, left: 160 },
            bottom: { top: 999, left: 999 },
          },
          midium: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
          large: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
        },
      },
    },
    {
      h_res: 480,
      v_res: 80,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 28,
          ko: 28,
          ja: 28,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 65,
          ko: 65,
          ja: 65,
        },
      },
      text_limit: {
        small: {
          en: 15,
          ko: 15,
          ja: 15,
        },
        midium: {
          en: 12,
          ko: 12,
          ja: 12,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 25,
              left: 240,
            },
            center: {
              top: 40,
              left: 240,
            },
            bottom: {
              top: 55,
              left: 240,
            },
          },
          midium: {
            top: { top: 25, left: 240 },
            center: { top: 40, left: 240 },
            bottom: { top: 55, left: 240 },
          },
          large: {
            top: {
              top: 30,
              left: 240,
            },
            center: {
              top: 43,
              left: 240,
            },
            bottom: {
              top: 55,
              left: 240,
            },
          },
        },
      },
    },
    {
      h_res: 480,
      v_res: 80,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 28,
          ko: 28,
          ja: 28,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 48,
          ko: 48,
          ja: 48,
        },
      },
      text_limit: {
        small: {
          en: 16,
          ko: 16,
          ja: 16,
        },
        midium: {
          en: 13,
          ko: 13,
          ja: 13,
        },
        large: {
          en: 7,
          ko: 7,
          ja: 7,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 18, left: 240 },
            center: { top: 24, left: 240 },
            bottom: { top: 28, left: 240 },
          },
          midium: {
            top: { top: 22, left: 240 },
            center: { top: 22, left: 240 },
            bottom: { top: 22, left: 240 },
          },
          large: {
            top: { top: 999, left: 240 },
            center: { top: 999, left: 240 },
            bottom: { top: 999, left: 240 },
          },
        },
        second_line: {
          small: {
            top: { top: 52, left: 240 },
            center: { top: 60, left: 240 },
            bottom: { top: 62, left: 240 },
          },
          midium: {
            top: { top: 62, left: 240 },
            center: { top: 62, left: 240 },
            bottom: { top: 62, left: 240 },
          },
          large: {
            top: { top: 52, left: 240 },
            center: { top: 60, left: 240 },
            bottom: { top: 62, left: 240 },
          },
        },
      },
    },
    {
      h_res: 160,
      v_res: 160,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 48,
          ko: 48,
          ja: 48,
        },
      },
      text_limit: {
        small: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        midium: {
          en: 4,
          ko: 4,
          ja: 4,
        },
        large: {
          en: 3,
          ko: 3,
          ja: 3,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 41,
              left: 80,
            },
            center: {
              top: 80,
              left: 80,
            },
            bottom: {
              top: 119,
              left: 80,
            },
          },
          midium: {
            top: {
              top: 41,
              left: 80,
            },
            center: {
              top: 80,
              left: 80,
            },
            bottom: {
              top: 119,
              left: 80,
            },
          },
          large: {
            top: {
              top: 41,
              left: 80,
            },
            center: {
              top: 80,
              left: 80,
            },
            bottom: {
              top: 119,
              left: 80,
            },
          },
        },
      },
    },
    {
      h_res: 160,
      v_res: 160,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 20,
          ko: 20,
          ja: 20,
        },
        midium: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        large: {
          en: 48,
          ko: 48,
          ja: 48,
        },
      },
      text_limit: {
        small: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        midium: {
          en: 4,
          ko: 4,
          ja: 4,
        },
        large: {
          en: 3,
          ko: 3,
          ja: 3,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 22,
              left: 80,
            },
            center: {
              top: 61,
              left: 80,
            },
            bottom: {
              top: 99,
              left: 80,
            },
          },
          midium: {
            top: {
              top: 32,
              left: 80,
            },
            center: {
              top: 59,
              left: 80,
            },
            bottom: {
              top: 89,
              left: 80,
            },
          },
          large: {
            top: {
              top: 32,
              left: 80,
            },
            center: {
              top: 59,
              left: 80,
            },
            bottom: {
              top: 89,
              left: 80,
            },
          },
        },
        second_line: {
          small: {
            top: {
              top: 61,
              left: 80,
            },
            center: {
              top: 99,
              left: 80,
            },
            bottom: {
              top: 138,
              left: 80,
            },
          },
          midium: {
            top: {
              top: 81,
              left: 80,
            },
            center: {
              top: 109,
              left: 80,
            },
            bottom: {
              top: 138,
              left: 80,
            },
          },
          large: {
            top: {
              top: 81,
              left: 80,
            },
            center: {
              top: 109,
              left: 80,
            },
            bottom: {
              top: 138,
              left: 80,
            },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 160,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        midium: {
          en: 40,
          ko: 40,
          ja: 40,
        },
        large: {
          en: 56,
          ko: 56,
          ja: 56,
        },
      },
      text_limit: {
        small: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 40,
              left: 160,
            },
            center: {
              top: 80,
              left: 160,
            },
            bottom: {
              top: 120,
              left: 160,
            },
          },
          midium: {
            top: {
              top: 40,
              left: 160,
            },
            center: {
              top: 80,
              left: 160,
            },
            bottom: {
              top: 120,
              left: 160,
            },
          },
          large: {
            top: {
              top: 40,
              left: 160,
            },
            center: {
              top: 80,
              left: 160,
            },
            bottom: {
              top: 120,
              left: 160,
            },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 160,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 34,
          ko: 34,
          ja: 34,
        },
        midium: {
          en: 40,
          ko: 40,
          ja: 40,
        },
        large: {
          en: 50,
          ko: 50,
          ja: 50,
        },
      },
      text_limit: {
        small: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 23, left: 160 },
            center: { top: 57, left: 160 },
            bottom: { top: 91, left: 160 },
          },
          midium: {
            top: { top: 40, left: 160 },
            center: { top: 59, left: 160 },
            bottom: { top: 80, left: 160 },
          },
          large: {
            top: { top: 40, left: 160 },
            center: { top: 59, left: 160 },
            bottom: { top: 80, left: 160 },
          },
        },
        second_line: {
          small: {
            top: { top: 69, left: 160 },
            center: { top: 103, left: 160 },
            bottom: { top: 137, left: 160 },
          },
          midium: {
            top: { top: 90, left: 160 },
            center: { top: 113, left: 160 },
            bottom: { top: 130, left: 160 },
          },
          large: {
            top: { top: 90, left: 160 },
            center: { top: 113, left: 160 },
            bottom: { top: 130, left: 160 },
          },
        },
      },
    },
    {
      h_res: 480,
      v_res: 240,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 52,
          ko: 52,
          ja: 52,
        },
        midium: {
          en: 58,
          ko: 58,
          ja: 58,
        },
        large: {
          en: 70,
          ko: 70,
          ja: 70,
        },
      },
      text_limit: {
        small: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 60, left: 240 },
            center: { top: 120, left: 240 },
            bottom: { top: 180, left: 240 },
          },
          midium: {
            top: { top: 60, left: 240 },
            center: { top: 120, left: 240 },
            bottom: { top: 180, left: 240 },
          },
          large: {
            top: { top: 60, left: 240 },
            center: { top: 120, left: 240 },
            bottom: { top: 180, left: 240 },
          },
        },
      },
    },
    {
      h_res: 480,
      v_res: 240,
      rotate: 'H',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 58,
          ko: 58,
          ja: 58,
        },
        midium: {
          en: 58,
          ko: 58,
          ja: 58,
        },
        large: {
          en: 70,
          ko: 70,
          ja: 70,
        },
      },
      text_limit: {
        small: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 50, left: 240 },
            center: { top: 80, left: 240 },
            bottom: { top: 120, left: 240 },
          },
          midium: {
            top: { top: 50, left: 240 },
            center: { top: 80, left: 240 },
            bottom: { top: 120, left: 240 },
          },
          large: {
            top: { top: 50, left: 240 },
            center: { top: 80, left: 240 },
            bottom: { top: 120, left: 240 },
          },
        },
        second_line: {
          small: {
            top: { top: 125, left: 240 },
            center: { top: 155, left: 240 },
            bottom: { top: 195, left: 240 },
          },
          midium: {
            top: { top: 125, left: 240 },
            center: { top: 155, left: 240 },
            bottom: { top: 195, left: 240 },
          },
          large: {
            top: { top: 125, left: 240 },
            center: { top: 155, left: 240 },
            bottom: { top: 195, left: 240 },
          },
        },
      },
    },
    {
      h_res: 480,
      v_res: 320,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 52,
          ko: 52,
          ja: 52,
        },
        midium: {
          en: 58,
          ko: 58,
          ja: 58,
        },
        large: {
          en: 70,
          ko: 70,
          ja: 70,
        },
      },
      text_limit: {
        small: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 70, left: 240 },
            center: { top: 160, left: 240 },
            bottom: { top: 249, left: 240 },
          },
          midium: {
            top: { top: 74, left: 240 },
            center: { top: 160, left: 240 },
            bottom: { top: 246, left: 240 },
          },
          large: {
            top: { top: 80, left: 240 },
            center: { top: 160, left: 240 },
            bottom: { top: 240, left: 240 },
          },
        },
      },
    },
    {
      h_res: 480,
      v_res: 320,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 52,
          ko: 52,
          ja: 52,
        },
        midium: {
          en: 58,
          ko: 58,
          ja: 58,
        },
        large: {
          en: 70,
          ko: 70,
          ja: 70,
        },
      },
      text_limit: {
        small: {
          en: 8,
          ko: 8,
          ja: 8,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 6,
          ko: 6,
          ja: 6,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 68, left: 240 },
            center: { top: 130, left: 240 },
            bottom: { top: 190, left: 240 },
          },
          midium: {
            top: { top: 63, left: 240 },
            center: { top: 125, left: 240 },
            bottom: { top: 187, left: 240 },
          },
          large: {
            top: { top: 58, left: 240 },
            center: { top: 120, left: 240 },
            bottom: { top: 182, left: 240 },
          },
        },
        second_line: {
          small: {
            top: { top: 127, left: 240 },
            center: { top: 189, left: 240 },
            bottom: { top: 250, left: 240 },
          },
          midium: {
            top: { top: 131, left: 240 },
            center: { top: 193, left: 240 },
            bottom: { top: 255, left: 240 },
          },
          large: {
            top: { top: 138, left: 240 },
            center: { top: 200, left: 240 },
            bottom: { top: 262, left: 240 },
          },
        },
      },
    },
  ],
  AOM60001: [
    {
      h_res: 320,
      v_res: 64,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 1,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        midium: {
          en: 48,
          ko: 48,
          ja: 48,
        },
        large: {
          en: 61,
          ko: 61,
          ja: 61,
        },
      },
      text_limit: {
        small: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        midium: {
          en: 7,
          ko: 7,
          ja: 7,
        },
        large: {
          en: 5,
          ko: 5,
          ja: 5,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: {
              top: 999,
              left: 999,
            },
            center: {
              top: 999,
              left: 999,
            },
            bottom: {
              top: 999,
              left: 999,
            },
          },
          midium: {
            top: {
              top: 999,
              left: 999,
            },
            center: {
              top: 35,
              left: 160,
            },
            bottom: {
              top: 999,
              left: 999,
            },
          },
          large: {
            top: {
              top: 999,
              left: 999,
            },
            center: {
              top: 35,
              left: 160,
            },
            bottom: {
              top: 999,
              left: 999,
            },
          },
        },
      },
    },
    {
      h_res: 320,
      v_res: 64,
      rotate: 'V',
      animation_type_default: 'static',
      font_size_default: 'small',
      vertical_align_default: 'center',
      multi_line_default: 'Y',
      multi_line_type: 2,
      letter_spacing: {
        small: 100,
        midium: 30,
        large: 30,
      },
      font_size: {
        small: {
          en: 30,
          ko: 30,
          ja: 30,
        },
        midium: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        large: {
          en: 0,
          ko: 0,
          ja: 0,
        },
      },
      text_limit: {
        small: {
          en: 11,
          ko: 11,
          ja: 11,
        },
        midium: {
          en: 0,
          ko: 0,
          ja: 0,
        },
        large: {
          en: 0,
          ko: 0,
          ja: 0,
        },
      },
      text_position: {
        first_line: {
          small: {
            top: { top: 999, left: 999 },
            center: { top: 17, left: 160 },
            bottom: { top: 999, left: 999 },
          },
          midium: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
          large: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
        },
        second_line: {
          small: {
            top: { top: 999, left: 999 },
            center: { top: 47, left: 160 },
            bottom: { top: 999, left: 999 },
          },
          midium: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
          large: {
            top: { top: 999, left: 999 },
            center: { top: 999, left: 999 },
            bottom: { top: 999, left: 999 },
          },
        },
      },
    },
  ],
};

export default animationJSON;
